export function removeQueryParam(urlString: string, paramToRemove: string) {
  const url = new URL(urlString);
  url.searchParams.delete(paramToRemove);
  return url.toString();
}
